import { Box, Skeleton, Grid } from "@mui/material";

const JobsCardsSkeleton = () => {
  const skeletonCards = Array(6).fill(null); // matching visible job cards in image

  return (
    <Box sx={{ width: "95%", display: "flex", gap: 2, padding: 2 }}>
      {/* Left section for job cards */}
      <Grid
        container
        spacing={2}
        sx={{
          flex: 3,
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
        }}
      >
        {skeletonCards.map((_, index) => (
          <Box
            key={index}
            sx={{
              borderRadius: 2,
              padding: 2,
              boxShadow: 2,
              border: "1px solid #ddd",
              minHeight: 300,
            }}
          >
            <Skeleton variant="text" width="40%" />
            <Skeleton variant="text" width="20%" />
            <Skeleton variant="text" width="80%" sx={{ mt: 1 }} />
            <Skeleton variant="text" width="60%" />
            <Skeleton variant="text" width="30%" />
            <Skeleton variant="rectangular" height={40} sx={{ mt: 1 }} />
            <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
              <Skeleton variant="rounded" width={50} height={25} />
              <Skeleton variant="rounded" width={50} height={25} />
              <Skeleton variant="rounded" width={50} height={25} />
            </Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}
            >
              <Skeleton variant="rounded" width={80} height={35} />
              <Skeleton variant="rounded" width={80} height={35} />
            </Box>
          </Box>
        ))}
      </Grid>

      {/* Right section for candidate cards */}
      <Box sx={{ width: "40%", flex: 1, boxShadow: 2, p: 1, borderRadius: 2 }}>
        <Skeleton variant="rounded" height={50} />
        <Box sx={{ mt: 2 }}>
          {[...Array(5)].map((_, idx) => (
            <Box
              key={idx}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                p: 2,
                border: "1px solid #ddd",
                borderRadius: 2,
                boxShadow: 2,
                mb: 2,
              }}
            >
              <Skeleton variant="circular" width={50} height={50} />
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="60%" />
                <Skeleton variant="text" width="40%" />
              </Box>
              <Skeleton variant="rounded" width={50} height={30} />
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default JobsCardsSkeleton;
